import React, { useEffect, useState } from 'react';
import PageHeading from '../../components/PageHeading/PageHeading';
import MuiTable from '../../components/MuiTable/MuiTable';
import { useNavigate } from 'react-router-dom';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import { useDispatch } from 'react-redux';
import instance from '../../service/axiosInstane';
import qs from 'qs';
import { flashBarTheme } from '../../config/flashBar';
import {
  CrawlJobProgressStatus,
  RequestMapping,
  RequestType,
  SortOrderType,
  StatusMapping,
} from '../../config/enum';
import { totalPages } from '../../config/helpers';
import SearchInput from '../../components/SearchInput/SearchInput';
import MultipleFilter from '../../components/MultipleFilter/MultipleFilter';

const columns = [
  {
    id: 'host',
    label: 'Host',
    minWidth: 70,
    align: 'left',
  },
  {
    id: 'siteNumber',
    label: 'Site Number',
    minWidth: 70,
    align: 'left',
  },
  {
    id: 'progressStatus',
    label: 'Status',
    minWidth: 70,
    align: 'left',
  },
  {
    id: 'requestType',
    label: 'Crawl type',
    minWidth: 70,
    align: 'left',
  },
  {
    id: 'organizationName',
    label: 'Organization',
    minWidth: 70,
    align: 'left',
  },
  {
    id: 'createdDate',
    label: 'Created Date',
    minWidth: 70,
    align: 'center',
  },
  {
    id: 'action',
    label: 'Action',
    minWidth: 0,
    align: 'right',
  },
];

const statusObj = [
  {
    name: 'Pending',
    id: 1,
  },
  {
    name: 'Crawling',
    id: 2,
  },
  {
    name: 'Indexing',
    id: 3,
  },
  {
    name: 'Completed',
    id: 4,
  },
  {
    name: 'Error',
    id: 5,
  },
  {
    name: 'Terminated',
    id: 6,
  },
];

type StateProps = {
  page: number;
  pageSize: number;
  searchText: string;
  sortBy: string;
  sortOrder: string;
  StatusFilter: number[];
  OrganizationFilter: string[];
};

type ResponseProps = {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  results?: ResultProps[];
};

type ResultProps = {
  id: string;
  organizationId: string;
  host: string;
  organizationName: string;
  totalPages: number;
  requestType: number;
  progressStatus: number;
  createdDate: string;
  siteNumber?: number;
};

type OrganizationProps = {
  id: string;
  name: string;
};

const CrawlJobs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(20);
  const [totalRowCount, setTotalRowCount] = useState<number>(0);
  const [crawljobs, setCrawlJob] = useState<ResultProps[]>([]);
  const [requestState, setRequestState] = useState<StateProps>({
    page: page,
    pageSize: limit,
    searchText: '',
    sortBy: '',
    sortOrder: SortOrderType.ASC,
    StatusFilter: [1,6,2],
    OrganizationFilter: [],
  });
  const [organizations, setOrganizations] = useState<OrganizationProps[]>([
    {
      id: '',
      name: '',
    },
  ]);

  const rootFilter: any = [
    {
      Heading: 'Progress Status',
      data: statusObj,
    },
    {
      Heading: 'Organization',
      data: organizations,
    },
  ];

  useEffect(() => {
    const breadcrumb = [{ path: '/crawljobs', name: 'Crawl Jobs' }];
    dispatch(update_breadcrumb(breadcrumb));
    getCrawlJobs(requestState);
    getAllOrganization();
  }, []);

  //Getting all DMCS Files
  const getCrawlJobs = async (obj: StateProps) => {
    dispatch(updateIsLoading(true));
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    await instance
      .get(`/crawl-jobs?${queryString}`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotResponse = (data: ResponseProps) => {
    setCrawlJob(data?.results as ResultProps[]);
    setTotalRowCount(data?.totalCount);
    dispatch(updateIsLoading(false));
  };

  const getAllOrganization = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get(`/organizations`)
      .then((response) => {
        if (response.status === 200) {
          gotOrgResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotOrgResponse = (data: OrganizationProps[]) => {
    setOrganizations(data);
    dispatch(updateIsLoading(false));
  };

  //Pagination
  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getCrawlJobs({ ...requestState, page: page, pageSize: limit });
      setPage(page);
    },
    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getCrawlJobs({
          ...requestState,
          page: page + 1,
          pageSize: limit,
          StatusFilter: requestState.StatusFilter,
          OrganizationFilter: requestState.OrganizationFilter,
        });
        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getCrawlJobs({
          ...requestState,
          page: page - 1,
          pageSize: limit,
          StatusFilter: requestState.StatusFilter,
          OrganizationFilter: requestState.OrganizationFilter,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getCrawlJobs({
          ...requestState,
          page: 1,
          pageSize: limit,
          StatusFilter: requestState.StatusFilter,
          OrganizationFilter: requestState.OrganizationFilter,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getCrawlJobs({
          ...requestState,
          page: totalPages(totalRowCount, limit),
          pageSize: limit,
          StatusFilter: requestState.StatusFilter,
          OrganizationFilter: requestState.OrganizationFilter,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },

    limitHandler: (item: number) => {
      getCrawlJobs({
        ...requestState,
        page: 1,
        pageSize: item,
        StatusFilter: requestState.StatusFilter,
        OrganizationFilter: requestState.OrganizationFilter,
      });
      setLimit(item);
      setPage(1);
    },
  };

  const viewRecord = (row: ResultProps) => {
    navigate(`/crawlView/${row.id}`);
  };

  //Search
  const onSearchHanlder = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setRequestState({ ...requestState, searchText: e.target.value });
  };

  const searchHandler = () => {
    getCrawlJobs({
      ...requestState,
      searchText: requestState.searchText,
      pageSize: limit,
    });
  };

  const onClearSearch = () => {
    setRequestState({
      ...requestState,
      searchText: '',
      page: page,
      pageSize: limit,
    });
    getCrawlJobs({
      ...requestState,
      searchText: '',
      page: page,
      pageSize: limit,
    });
  };

  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchHandler();
    }
  };

  const filterHandler = (arg: any) => {
    const orgArr = [];
    const statusArr = [];
    for (let i = 0; i < arg.length; i++) {
      if (arg[i]?.type == 'Progress Status') {
        statusArr.push(arg[i]?.selectedMenu);
      } else {
        orgArr.push(arg[i]?.selectedMenu);
      }
    }
    getCrawlJobs({
      ...requestState,
      page: page,
      pageSize: limit,
      StatusFilter: statusArr,
      OrganizationFilter: orgArr,
    });
    setRequestState({
      ...requestState,
      OrganizationFilter: orgArr,
      StatusFilter: statusArr,
    });
    setPage(1);
  };

  //Sorting
  const sortRecord = (fieldName: string, sortOrder: string) => {
    getCrawlJobs({
      ...requestState,
      sortOrder: sorting(sortOrder),
      sortBy: fieldName,
      page: page,
      pageSize: limit,
      StatusFilter: requestState.StatusFilter,
      OrganizationFilter: requestState.OrganizationFilter,
    });
    setRequestState({
      ...requestState,
      sortBy: fieldName,
      sortOrder: sorting(sortOrder),
    });
  };

  const sorting = (sortOrder: string) => {
    let temp = '';
    if (sortOrder == SortOrderType.DESC) {
      temp = SortOrderType.ASC;
    } else {
      temp = SortOrderType.DESC;
    }
    setRequestState({ ...requestState, sortOrder: temp });
    return temp;
  };

  return (
    <>
      <div className="px-2 py-1 ">
        <PageHeading label="Crawl Jobs" />
        <div className="bg-white p-2 rounded-rounded-sm shadow-lg ">
          <div className="xl:flex items-center">
            <div className="w-full xl:flex items-center justify-between p-2">
              <div className="mt-3">
                {' '}
                <SearchInput
                  value={requestState.searchText}
                  onChange={onSearchHanlder}
                  onSearch={searchHandler}
                  onClear={onClearSearch}
                  handleEnterKeyPress={handleEnterKeyPress}
                />
              </div>

              <div className="mt-3 ">
                <MultipleFilter
                  filterHandler={filterHandler}
                  rootFilter={rootFilter}
                  initialFilterData={[
                    {
                      type: 'Progress Status',
                      selectedMenu: [1, 6, 2],
                    },
                  ]}
                />
              </div>
            </div>
          </div>
          <div className="mt-2">
            <MuiTable
              columns={columns}
              rows={crawljobs.map((crawljobs: ResultProps) => ({
                ...crawljobs,
                progressStatus:
                  StatusMapping[crawljobs.progressStatus as CrawlJobProgressStatus],
                requestType: RequestMapping[crawljobs.requestType as RequestType],
              }))}
              page={page}
              limit={limit}
              totalRowCount={totalRowCount}
              paginateHandler={paginateHandler}
              onSortHandler={sortRecord}
              sortOrder={requestState.sortOrder}
              onViewHandler={viewRecord}
              showView={true}
              sortArray={['createdDate']}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CrawlJobs;
